<script>
import appConfig from "@/app.config";
import moment from "moment";
import { Tracking } from "@/services/westore/entities";

export default {
  page: {
    title: "Tracking Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      showContentLoader: true,
      history: [],
      itemDetails: {},
      marker: { position: { lat: 24.421555, lng: 54.576599 } },
      center: { lat: 24.421555, lng: 54.576599 },
    };
  },
  mounted() {
    this.fetchTracking();
  },
  methods: {
    convertDate(timestampValue) {
      return moment.unix(timestampValue).format("DDMMM,yyyy");
    },
    async fetchTracking() {
      this.loader = true;
      await Tracking.getTracking(this.$route.params.id)
        .then((res) => {
          this.itemDetails = res.data;
          this.showContentLoader = !this.showContentLoader;
        })
        .catch((error) => {
          this.loader = false;
          console.error("There was an error!", error);
          this.$toast.error(error.response.data.message);
        })
        .finally(() => (this.loader = false));
    },
  },
};
</script>

<template>
  <section class="tracking-wrapper">
    <v-container>
      <v-row>
        <v-col cols lg="10" md="12" class="mx-auto">
          <div class="logo text-center mb-8">
            <img
              src="@/assets/images/tracking/logo.svg"
              @click="$router.push('/')"
              height="40"
              role="button"
              alt="logo"
            />
          </div>
          <v-card
            v-if="showContentLoader"
            style="height: 450px"
            class="tracking-card px-lg-15 py-lg-10 px-5 py-10 elevation-0 d-flex justify-center align-center"
          >
            <v-progress-circular
              :size="70"
              :width="7"
              color="secondary"
              indeterminate
            ></v-progress-circular>
          </v-card>

          <v-card
            v-else
            class="tracking-card px-lg-15 py-lg-10 px-5 py-10 elevation-0"
          >
            <h3>order tracking</h3>

            <router-link :to="{ name: 'tracking-order' }">
              <a class="back-btn">
                <v-icon size="14">$vuetify.icons.chevronLeft</v-icon>
                back
              </a>
            </router-link>

            <!--Order-details-->
            <div class="order-details w-100">
              <div class="details-1">
                <p>Order placed</p>
                <p>{{ convertDate(itemDetails.created) }}</p>
              </div>
              <div class="details-2">
                <div>
                  <p>Order</p>
                  <p>{{ itemDetails.order_number }}</p>
                </div>
                <div>
                  <p>Total fess</p>
                  <p>{{ itemDetails.total }}AED</p>
                </div>
                <div>
                  <p>Ship to</p>
                  <p>{{ itemDetails.customer_name }}</p>
                </div>
              </div>
            </div>
            <!--Order-Status-->
            <p class="status">
              <span>order status: </span><span>{{ itemDetails.status }}</span>
            </p>
            <!--Order-steps-->
            <div class="wrapper-stepper mt-10">
              <div class="stepper">
                <div
                  class="stepper-item"
                  v-for="(item, index) in itemDetails.history"
                  :key="index"
                  :style="{
                    display:
                      item.status === 'None' || item.status === 'Cancelled'
                        ? 'none'
                        : 'flex',
                  }"
                >
                  <div class="stepper-item-counter">
                    <div
                      class="icon-wrapper"
                      :class="[item.timestamp !== null ? 'active' : '']"
                    >
                      <i
                        class="bx bx-check"
                        v-if="item.status === 'Order placed'"
                      ></i>
                      <v-icon v-if="item.status === 'In-progress'"
                        >$vuetify.icons.inProgress</v-icon
                      >
                      <v-icon v-if="item.status === 'Dispatched'"
                        >$vuetify.icons.dispatchedIcon</v-icon
                      >
                      <v-icon v-if="item.status === 'Out for delivery'"
                        >$vuetify.icons.outDeliveryIcon</v-icon
                      >
                      <v-icon v-if="item.status === 'Delivered'"
                        >$vuetify.icons.deliverdStatus</v-icon
                      >
                    </div>

                    <p class="stepper-item-title">
                      {{ item.status }}
                    </p>
                    <p class="stepper-item-date" v-if="item.timestamp !== null">
                      {{ convertDate(item.timestamp) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <!--shopping-wrapper-->
            <div class="shopping-wrapper">
              <!--shopping-info-->
              <div class="shopping-info">
                <div>
                  <p>shipping info</p>
                  <p>{{ itemDetails.customer_name }}</p>
                </div>
                <div>
                  <p>Courier</p>
                  <p>weStore</p>
                </div>
              </div>
              <!--Map-->
              <div class="map">
                <GmapMap
                  :center="center"
                  :zoom="12"
                  map-style-id="roadmap"
                  style="width: 100%; height: 100px"
                >
                  <GmapMarker :position="marker.position" />
                </GmapMap>
                <div
                  class="map-placeholder"
                  v-if="itemDetails.lat || itemDetails.lng === null"
                >
                  <p class="mb-0">live tracking is not available!</p>
                </div>
              </div>
            </div>
          </v-card>
          <div class="text-center mb-7 mt-5">
            <img
              src="@/assets/images/poweredBy.svg"
              height="50"
              alt="poweredBy"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style lang="scss" scoped>
@import "../../../design/custom/pages/tracking-order.scss";
.slide-fade-enter-active {
  transition: all 0.5s ease-in;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 0.8);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
<style lang="scss">
.stepper {
  .icon-wrapper {
    svg path {
      fill: #57697b;
    }
  }
  .icon-wrapper.active {
    svg path {
      fill: #ffffff;
    }
  }
}
</style>
